import { gql } from '@apollo/client';

export const STAFF_QUERY = gql`
  query staff(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    staff(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      staff {
        id
      }
      totalPages
      totalCount
    }
  }
`;

export const STAFF_LIST_QUERY = gql`
  query usersFilter(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    usersFilter(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      users {
        id
        firstName
        middleName
        lastName
        email
        profile
        phone
        loginEnabled
        roles {
          id
          name
        }
        callingCode {
          id
          callingCode
        }
        permissions {
          id
          name
          permissionName
        }

        addresses {
          id
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }
        assignedTraders {
          id
          firstName
          middleName
          lastName
          email
          phone
          callingCode {
            id
            callingCode
          }
          rmAssignedAt
        }
      }
      totalPages
      totalCount
    }
  }
`;

export const STAFF_LIST_QUERY_SUBSCRIPTION = gql`
  subscription usersFilter(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    usersFilter(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      user {
        id
        firstName
        middleName
        lastName
        email
        profile
        phone
        loginEnabled
        roles {
          id
          name
        }
        callingCode {
          id
          callingCode
        }
        permissions {
          id
          name
          permissionName
        }

        addresses {
          id
          city {
            id
            cityName
          }
          state {
            id
            stateName
          }
        }
        assignedTraders {
          id
          firstName
          middleName
          lastName
          email
          phone
          callingCode {
            id
            callingCode
          }
          rmAssignedAt
        }
      }
      totalPages
      totalCount
      action
    }
  }
`;

export const USER_EXISTS = gql`
  query isUserExists(
    $columnName: String
    $value: String
    $callingCode: String
  ) {
    isUserExists(
      columnName: $columnName
      value: $value
      callingCode: $callingCode
    ) {
      id
      firstName
      middleName
      lastName
      email
      phone
      callingCode {
        id
        callingCode
      }
      roles {
        id
        name
      }
    }
  }
`;

export const UPDATE_STAFF = gql`
  mutation updateUser($userInputDTO: UserInputDTO) {
    updateUser(userInputDTO: $userInputDTO)
  }
`;

export const CREATE_STAFF = gql`
  mutation createUser($userInputDTO: UserInputDTO) {
    createUser(userInputDTO: $userInputDTO)
  }
`;

export const DELETE_STAFF = gql`
  mutation deleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

export const UPDATE_STAFF_LOGIN_STATUS = gql`
  mutation UpdateStaffLoginStatus($userId: ID!, $loginEnabled: Boolean!) {
    updateStaffLoginStatus(userId: $userId, loginEnabled: $loginEnabled)
  }
`;

export const ASSIGN_TRADERS_TO_ANOTHER_RM = gql`
  mutation assignTradersToAnotherRM($traders: [ID], $dedicatedRM: ID) {
    assignTradersToAnotherRM(traders: $traders, dedicatedRM: $dedicatedRM)
  }
`;

export const ASSIGN_TRADERS_TO_ANOTHER_BDE = gql`
  mutation assignTradersToAnotherBDE($traders: [ID], $dedicatedBDE: ID) {
    assignTradersToAnotherBDE(traders: $traders, dedicatedBDE: $dedicatedBDE)
  }
`;

export const ASSIGN_TRADERS_TO_DEDICATED_PURCHASE_MANAGER = gql`
  mutation AssignPM($traders: [ID], $managerId: ID) {
    assignTradersToDedicatedPurchaseManager(
      traders: $traders
      dedicatedPurchaseManager: $managerId
    )
  }
`;

export const EXPORTS_USERS = gql`
  query exportUsers(
    $filter: [FilterMap]
    $sortCol: String
    $sortDirection: String
  ) {
    exportUsers(
      filter: $filter
      sortCol: $sortCol
      sortDirection: $sortDirection
    )
  }
`;

export const GET_UNASSIGNED_VENDORS = gql`
  query getUnassignedVendors($pageNo: Int, $pageSize: Int) {
    getUnassignedVendors(pageNo: $pageNo, pageSize: $pageSize) {
      vendors {
        id
        vendorName
        phone
        email
      }
      totalElements
      totalPages
      currentPage
      pageSize
    }
  }
`;
